import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface SystemUser {
  id: string;
  email: string;
  name: string | null;
  isSystem: true;
}

interface SystemAuthState {
  user: SystemUser | null;
  token: string | null;
  setAuth: (user: SystemUser, token: string) => void;
  logout: () => void;
  isAuthenticated: () => boolean;
}

export const useSystemAuthStore = create<SystemAuthState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      setAuth: (user, token) => {
        localStorage.setItem('system-token', token);
        set({ user, token });
      },
      logout: () => {
        localStorage.removeItem('system-token');
        localStorage.removeItem('system-auth-storage');
        set({ user: null, token: null });
      },
      isAuthenticated: () => {
        const { user, token } = get();
        return !!user && !!token;
      },
    }),
    {
      name: 'system-auth-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
